import Home from "./Component/Home/Home";

function App() {
  return (
    <div className="">
      <Home/>
    </div>
  );
}

export default App;
